<template>
    <div id="graphic" v-touch:swipe="swipeHandler"
    :style="{
        'background': colors.theme == 'dark' ? `linear-gradient(180deg, ${colors[colors.theme].from} 0%,  ${colors[colors.theme].to} 100%)` : '#fff',
        'color': colors.theme == 'dark' ? '#fff' : '#000',
    }">
        <!-- <scenary-options></scenary-options> -->
        <Navbar></Navbar>
        <report-header :pageNumberIndicator="pageNumberIndicator" :title="headerTitle" backRoute="/report/performance" :backOption="true" backTo="Performance"></report-header>
        <report-pagination
            :activeBefore="pagination.activeBefore"
            :activeNext="pagination.activeNext"
            :nextRoutePagination="pagination.nextRoutePagination"
            :beforeRoutePagination="pagination.beforeRoutePagination"
        ></report-pagination>
        <chart-radar id="chart-header"></chart-radar>
        <div class="color-label"
        :style="{
            background: colors.theme == 'dark' ? '#000' : '#f0f0f0'  
        }">
            <div class="piece" :style="{background: colors.secondary}"></div>
            <span class="label-you" :style="{color: colors.secondary}">{{$t("views.report.performance.hints_info_you")}}</span>
        </div>        
        <!-- <button-next title="descrição do perfil" nextRoute="competences"></button-next> -->
    </div>
</template>

<script>
import ChartRadar from '../../components/shared/report/charts/ChartRadar'
import ReportPagination from '../../components/shared/report/ReportPagination'
import Header from '../../components/shared/report/Header'
import ButtonNext from '../../components/shared/report/ButtonNext'
import ScenaryOptions from '../../components/shared/report/ScenaryOptions'
import Navbar from "../../components/shared/header/Navbar";
export default {
    name: 'Graphic',
    props:[],
    components:{
        'chart-radar': ChartRadar,
        'report-pagination': ReportPagination,
        'report-header': Header,
        'button-next': ButtonNext,
        'scenary-options': ScenaryOptions,
        Navbar
    },
    data(){
        return{
            pagination:{
                activeBefore: true,
                activeNext: true,
                beforeRoutePagination: 'performance',
                nextRoutePagination: 'competences'
            },
            colors: {},
            pageNumberIndicator: 2,
            headerTitle: this.$t("views.report.performance.componentsData.buttonNextTitle"),
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    methods:{
        swipeHandler (direction) {
            if(direction == 'right') this.$router.push(this.pagination.beforeRoutePagination) 
            if(direction == 'left') this.$router.push(this.pagination.nextRoutePagination)
        }
    }
}
</script>

<style lang="scss" scoped>
#graphic{
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
}
    
#chart-header{
    flex: 1;
    position: relative;
} 
  .color-label{
    display: flex;
    background: #000;
    height: 5vh;
    justify-content: center;
    align-items: center;   
    
    .piece{
      width: 50px;
      height: 10px;
      border-radius: 20px;
      margin-right: 5px; 
    }
    span{
      text-transform: capitalize;
    }
    .label-you{
        margin-right:  25px;
    }
  }
</style>


